var supportDescriptors = require('core-js/internals/descriptors');
var defineProperty = require('core-js/internals/object-define-property').f;
var NAME = 'replace';
var proto = DOMTokenList.prototype;
function test(){
  var list = document.createElement("i").classList;
  return list.replace("a", "b") !== false;// return true, replace return void
}

// https://dom.spec.whatwg.org/#dom-domtokenlist-replace
if (supportDescriptors && (!proto.hasOwnProperty(NAME)) || test()) {
  defineProperty(proto, NAME, {
    configurable: true,
    value: function(token, newToken) {
      if (!this.contains(token)) {
        return false;
      }

      this.remove(token);
      this.add(token);

      return true;
    }
  });
}
